import dayjs from 'utils/dayjs';

/**
 * Merge all current / LY / forecast stats together into 1 array
 * @param {Object[]} current
 * @param {Object[]} lyFinal
 * @param {Object[]} lySpit
 * @param {Object[]} budget
 * @return {?Object[]} forecast
 */
export const mergeData = (current, lyFinal, lySpit, forecast, budget, dayComparison = true) => {
    let spitUnit = 'weeks';
    let lySpitAmount = 52;
    if (!dayComparison) {
        spitUnit = 'years';
        lySpitAmount = 1;
    }
    return current.map((currentRow) => {
        const lySpitDate = dayjs(currentRow.stayDate, 'YYYY-MM-DD').subtract(lySpitAmount, spitUnit).format('YYYY-MM-DD');
        const lyFinalMatch = lyFinal.find((row) => row.stayDate === lySpitDate);
        const lySpitMatch = lySpit.find((row) => row.stayDate === lySpitDate);
        const forecastMatch = (forecast || []).find((row) => row.stayDate === currentRow.stayDate);
        const budgetMatch = budget.find((row) => row.stayDate === currentRow.stayDate);

        return {
            stayDate: currentRow.stayDate,
            current: currentRow,
            lyFinal: lyFinalMatch,
            lySpit: lySpitMatch,
            forecast: forecastMatch,
            budget: budgetMatch,
        };
    });
};

/**
 * Format data for CSV export: swap rows & columns and apply formatter
 * @param  {Object[]} data
 * @param  {Object[]} rowsDefinitions - containing dataKey accessor and dataName
 * @param  {Function} formatter - function to format a value
 * @return {Object[]} formatted data ready for export
 */
export const formatForExport = (data, rowsDefinitions, formatter) => {
    const dateFormat = 'ddd DD MMM YY';
    return rowsDefinitions.reduce((accu, { dataName, dataKey }) => {
        let rowHasData = false;
        const values = data.reduce((objAccu, row) => {
            const value = dataKey(row);
            if (value !== null) rowHasData = true;
            return {
                ...objAccu,
                [dayjs(row.stayDate).format(dateFormat)]: value === null ? 'N/A' : formatter(value),
            };
        }, {});
        if (!rowHasData) return accu;
        return accu.concat({
            date: dataName,
            ...values,
        });
    }, []);
};
